import * as momentNs from 'moment';

const /** @type {?} */ moment = momentNs;
/**
 * @param {?} ktpNumber
 * @return {?}
 */
export function transformKtpData(ktpNumber: string) {
  const /** @type {?} */ dobInKtp = ktpNumber.substr(6, 6);
  const /** @type {?} */ isFemale = parseInt(dobInKtp.substr(0, 2)) > 40;

  let /** @type {?} */ birthDate;
  let /** @type {?} */ birthMonth;
  let /** @type {?} */ birthYear;

  if (isFemale) {
    birthDate = parseInt(dobInKtp.substr(0, 2)) - 40;
  } else {
    birthDate = dobInKtp.substr(0, 2);
  }

  birthMonth = parseInt(dobInKtp.substr(2, 2)) - 1;
  birthYear = dobInKtp.substr(4, 2);

  const /** @type {?} */ birthday = new Date(birthYear, birthMonth, birthDate);
  const /** @type {?} */ ktpBirthday = moment(birthday).format('YYYY-MM-DD');

  return {
    ktpBirthday,
  };
}
